  import React, {useState} from 'react';
  import {
    Modal,
    Box,
    Typography,
    TextField,
    MenuItem,
    Button,
    Stack,
    Divider,
    IconButton
  } from '@mui/material';
  import CloseIcon from '@mui/icons-material/Close';
  import { Formik, Form, Field } from 'formik';
  import * as Yup from 'yup';
  import { createStyleDesign } from '../../apis/apiList/styleDesignApi';
  import { useApp } from '../../context/AppContext';
  import { useMessage } from '../../context/MessageContext';

  // Validation schema
  const LogoSchema = Yup.object().shape({
    logoName: Yup.string().required('Logo name is required'),
    logoType: Yup.string().required('Logo type is required'),
    logoFile: Yup.mixed().required('Logo file is required')
  });

  const AddLogo = ({isOpen, onClose, organization, handleFileChange, updateList }) => {
      const [logoName, setLogoName] = useState('');
      const [logoType, setLogoType] = useState('');
      // const [file, setFile] = useState('');
      const { userDetails } = useApp();
      const [isLoading, setIsLoading] = useState(false);
      const { showMessage } = useMessage();

      const handleSubmit = async (name, type, file) =>{
        setIsLoading(true);
        const formData = new FormData();
        formData.append("name", name);
        formData.append("type", type);
        formData.append("organizationId", organization._id);
        formData.append("designType", 'logo');
        formData.append("folderid", organization.boxFolderId);
        // formData.append("userId", userDetails._id);
        formData.append("file", file);
        try {
          const response = await createStyleDesign(formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              "x-access-token": userDetails?.jwtToken
            },
          });
          console.log('response', response)
          if (response.success) {
            updateList(response.data?.style?.logos || [], 'logos', response.data?.sharedLink);
            showMessage(response.message, "success");
          }
          onClose()
        } catch (err) {
          console.error('Error uploading logo:', err);
          // Handle error (e.g., show a message to the user)
          showMessage(err?.response?.data?.message || 'Internal server issue', "error");
        } finally {
          setIsLoading(false);
        }
      }

      return (
        <Modal open={isOpen} onClose={onClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 500,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              maxWidth: "90%",
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ px: 4, py: 2 }}
              alignItems="center"
            >
              <Typography variant="h3">Add Logo</Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Stack>

            <Divider />

            <Formik
              initialValues={{
                logoName: "",
                logoType: "",
                logoFile: null,
              }}
              validationSchema={LogoSchema}
              onSubmit={(values) => {
                setLogoName(values.logoName);
                setLogoType(values.logoType);
                // handleFileChange({ target: { files: [values.logoFile] } });
                // setFile(values.logoFile);
                handleSubmit(values.logoName, values.logoType, values.logoFile);
                // onClose();
              }}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form>
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap={2}
                    sx={{ p: 4, pt: 3 }}
                  >
                    {/* Logo Name */}
                    <Field
                      as={TextField}
                      name="logoName"
                      label="Logo Name"
                      variant="outlined"
                      fullWidth
                      error={touched.logoName && Boolean(errors.logoName)}
                      helperText={touched.logoName && errors.logoName}
                    />

                    {/* Logo Type */}
                    <Field
                      as={TextField}
                      select
                      name="logoType"
                      label="Select Logo Type"
                      variant="outlined"
                      fullWidth
                      error={touched.logoType && Boolean(errors.logoType)}
                      helperText={touched.logoType && errors.logoType}
                    >
                      <MenuItem value="" disabled>
                        Select Logo Type
                      </MenuItem>
                      <MenuItem value="primary">Primary</MenuItem>
                      <MenuItem value="secondary">Secondary</MenuItem>
                    </Field>

                    {/* Upload Logo */}
                    <Box>
                      <Typography variant="subtitle1" fontWeight={500} mb={1}>
                        Upload Logo:
                      </Typography>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Button
                          variant="outlined"
                          component="label"
                          sx={{ bgcolor: "#f9fafb", borderColor: "#d1d5db" }}
                        >
                          Choose File
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(event) => {
                              setFieldValue(
                                "logoFile",
                                event.currentTarget.files[0]
                              );
                            }}
                          />
                        </Button>
                        <Typography variant="body2" color="text.secondary">
                          {values.logoFile?.name  ||
                            "No file selected"}
                        </Typography>
                      </Box>
                      {touched.logoFile && errors.logoFile && (
                        <Typography variant="caption" color="error">
                          {errors.logoFile}
                        </Typography>
                      )}
                    </Box>

                    {/* Save Button */}
                    <Box display="flex" justifyContent="flex-end" mt={2}>
                      <Button type="submit" variant="contained" disabled={isLoading}>
                        {isLoading ? "Saving..." : "Save Changes"}
                      </Button>
                    </Box>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal>
      );
  };

  export default AddLogo;
